import React from 'react';

interface IBlockWrapper {
  shouldHide: boolean;
  children?: React.ReactNode;
  shouldAvoidPadding?: boolean;
}

export const BlockWrapper = ({ children, shouldAvoidPadding, shouldHide }: IBlockWrapper) => <div className={`${shouldHide ? 'hidden' : ''} border-t border-t-bw03 hover:bg-bw02 w-full ${shouldAvoidPadding ? '' : 'py-[12px] px-[14px]'}`}>{children}</div>;
